import { makeObservable } from 'mobx'
import { Slide } from './Slide'
import { sortQuestions } from '../../../sources-of-truth/sortQuestions'

export class SoloQuizSlide extends Slide {
  isSolo = true
  afterConstructor() {
    makeObservable(this, {
      questions: true,
    })
  }

  get questions() {
    const soloQuizQuestions = this.meeting.questions.filter(
      (q) => q.slideId === this.meeting.currentSlide?.id && q.isQuiz
    )

    return sortQuestions({ questions: soloQuizQuestions, slideIds: [] })
  }
}
